import { cmdSetPayerInfo } from '../../general/modules/webAppFunctions';

type SetPayerInfoData = {
    name: string,
    totalValue: number
};

export class SetPayerInfoHandler {
    public handle(data: SetPayerInfoData): void {
        cmdSetPayerInfo(data.name, data.totalValue);
    }
}
